import React from 'react';
import { ColoredTextWithBG, _palette } from '@p81-common/ui';

export interface GridIsHaCellProps {
  value?: string;
}
export const GridIsHaCell = React.memo(function GridIsHaCell(
  props: GridIsHaCellProps
) {
  const { value } = props;

  return value ? (
    <ColoredTextWithBG
      colorObj={{
        backgroundColor: _palette.success[200],
        color: _palette.success[500]
      }}
      content="Online"
    />
  ) : (
    <ColoredTextWithBG
      colorObj={{
        backgroundColor: _palette.error[200],
        color: _palette.error[500]
      }}
      content="Offline"
    />
  );
});
